// extracted by mini-css-extract-plugin
export var growableInput = "_7s-0";
export var tagContainer = "_7s-2";
export var textInput = "_7s-1";